import React from 'react'

import {connect}  from  "react-redux"
import { createStructuredSelector } from 'reselect'


import { selectCartItems, selectCartTotal } from '../../redux/cart/cart.selector'

import "./checkout.scss"
import CheckoutItem from '../../components/checkoutItem/checkout-item'
const Checkout = ({total,cartItems,}) => {
    return (
        <div className='checkout-page'>
            {/* <div className="checkout-header">
            <div className="header-block">
                    <span>Product</span>
                </div>
                <div className="header-block">
                    <span>Description</span>
                </div>
                <div className="header-block">
                <span>Quantity</span>
                </div>
                <div className="header-block"><span>Price</span></div>
                <div className="header-block"><span>Remove</span></div>
                </div> */}
                {
                    cartItems.map(cartItem => {
                        return(
                            <CheckoutItem cartItem={cartItem} key={cartItem.id}/> 
                        )
                   
                    }
                    )
                }
                
                
            
            <div className='total'>
                    <span>TOTAL :{total}</span>
                </div>
                
        </div>
    )
}

const mapStateToProps =  createStructuredSelector({
    cartItems:selectCartItems,
    total:selectCartTotal
})

export default connect(mapStateToProps)(Checkout);
